import React from 'react'
import TearsheetTemplates from 'pages/IrwinAssistant/CustomerPreferences/TearsheetTemplates'

const GlobalTearsheetTemplates = () => (
  <TearsheetTemplates title="Global Tearsheet Templates" isGlobal />
)

export default GlobalTearsheetTemplates
